import React, { useEffect, useRef, useState } from 'react'
import Transactions from "./components/Transactions/Transactions";
import {useDispatch, useSelector} from "react-redux";
import transactionsActions from "../../store/transactionsStore/transactionsActions";
import debounce from "../../tools/debounce";
import TransactionsTypes from "../../store/transactionsStore/transactionsTypes";


export default function TransactionsComponent() {
    const dispatch = useDispatch()
    const {info} = useSelector(state => state.branchReducer)
    const profile = useSelector(state => state.profileReducer)
    const {page, data, status} = useSelector(state => state.transactionsReducer)
    const {payment_status} = useSelector(state => state.bonusesModalReducer)
    const {customer} = useSelector(state => state.clientInfoReducer)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [phone, setPhone] = useState('')
    const searchRef = useRef(null);

    const getTransactions = () => {
        dispatch(transactionsActions.getAllTransactions({
            branch_id: info && info.id, page, startDate, endDate, phone,
        }));
    }

    useEffect(() => {
        return () => {
            dispatch({ type: TransactionsTypes.CLEAR_TRANSACTIONS });
        }
    }, []);

    useEffect(() => {
        if (info) {
            debounce(()=>dispatch(transactionsActions.getAllTransactions({
                branch_id: info && info.id,
                page,
                startDate,
                endDate,
                phone,
            })), 100)
        }
    }, [page, info, endDate, startDate, payment_status])

    useEffect(() => {
        if (info) {
            dispatch({ type: TransactionsTypes.CLEAR_TRANSACTIONS_PAGE })
            debounce(()=>dispatch(transactionsActions.getAllTransactions({
                branch_id: info && info.id, page: 1, startDate, endDate, phone, searchRef,
            })), 1500)
        }
    }, [phone])

    const changePageAction = (page) => {
        dispatch(transactionsActions.changePage(page))
    }

    return (
        <Transactions
            searchRef={searchRef}
            orders={data.orders && data.orders.sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
            })}
            getTransactions={getTransactions}
            count={data.count || 0}
            page={page}
            profileInfo={profile}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            changePageAction={changePageAction}
            customer={customer}
            info={info}
            status={status}
            phone={phone}
            setPhone={setPhone}
        />
    )
}
